import {createTheme as createMuiTheme} from '@mui/material';
import {deepmerge} from '@mui/utils';
import {getStyleOverrides} from './style/overrides.js';

export const monospace = {fontFamily: "'Roboto Mono', monospace"};

export const mapBackground = '#191a1a';

const createTheme = theme =>
  createMuiTheme(
    deepmerge(theme, {
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 960,
          xl: 960,
        },
      },
      components: {
        ...getStyleOverrides(theme),
      },
    }),
  );

export default createTheme;
